$('.feature-play-video, .features-play').click((e) => {
  e.preventDefault();
  $(e.target).closest('.feature-block').find('.feature-block__play').addClass('show-video');
});

const setGridHeight = () => {
  const grid = $('.features-grid-container');
  $(grid).height($(grid).find('.features-grid').outerHeight());
};

$('.features-grid-container').on('DOMSubtreeModified', function () {
  setGridHeight();
});

setGridHeight();
$(window).resize(() => {
  setGridHeight();
});
